/* 各种接口 */
import config from '../config'
let baseUrl
let host = window.location.protocol + "//" + window.location.host;
if (host.indexOf('localhost') > -1 || host.indexOf('117.156') > -1 || host.indexOf('test.qiludev') > -1) {
  baseUrl = config.baseUrl.dev
} else if (host.indexOf('uat.qiludev') > -1) {
  baseUrl = config.baseUrl.uat
} else {
  baseUrl = host
}
// const baseUrl =
//   process.env.NODE_ENV == "development"
//     ? config.baseUrl.dev
//     : config.baseUrl.pro
// console.log('apis.js', baseUrl)
const apis = {
  // 前台投票页面
  voteInfo: baseUrl + '/api/vote/info',
  // 前台投票选项列表
  voteOptions: baseUrl + '/api/vote/options',
  // 前台投票选项排行榜
  voteLeaderBoard: baseUrl + '/api/vote/leaderboard',
  // 前台用户投票提交
  voteSubmit: baseUrl + '/api/vote/submit',
  // 前台投票选项详情
  voteOption: baseUrl + '/api/vote/option',
  // 活动投票详情
  voteGroupInfo: baseUrl + '/api/vote/groupinfo',
  // 获取匿名牌子
  voteAnonToken: baseUrl + '/api/vote/ticket',
};

export default apis